import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "reactstrap";
import "./AddButton.css";

export default class AddButton extends Component {
  render() {
    return (
        <Button
            onClick={() => this.props.handleCreateDialogToggle()}
            outline
            color="success"
            className={`btn ${this.props.className}`}
        >
          &nbsp;&nbsp;
          <FontAwesomeIcon className="sort-icon" icon="plus"/>
          &nbsp;&nbsp;{this.props.name}
        </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/AddButton/AddButton.js